<div
  class="checkbox-group-container"
  [class.label-top]="uiGroupLabelPosition === 'top'"
  [class.label-left]="uiGroupLabelPosition === 'left'"
  role="group"
  aria-labelledby="checkbox-group-container-label">
  <span class="checkbox-group-container-label" id="checkbox-group-container-label" *ngIf="uiGroupLabel">{{ uiGroupLabel }}</span>

  <div class="checkboxes-wrap">
    @for (option of options; track option.value) {
    <label class="ant-checkbox-group-item" [uiDisabled]="option.disabled || nzDisabled" [uiChecked]="option.checked!" (uiCheckedChange)="onCheckedChange(option, $event)" ui-checkbox>
      <ng-template *ngIf="uiLabelTemplate" [ngTemplateOutlet]="uiLabelTemplate"></ng-template>
      {{ option.label }}</label
    >
    }
  </div>
</div>
